import global from '@/core/global/global.js'
var url = '';
if (global.global.ispc) {
    url = 'Redackpc'
} else {
    url = 'mobileyd';
}
export default [{
    path: '/',
    name: '',
    component: resolve => require([`@/views/${url}/Home`], resolve),
    children: [{
        path: '/',
        name: '',
        meta: {
            title: '',
        },
        component: resolve => require([`@/views/Redackpc/firstPage/index`], resolve),
    },
    {
        path: '/cardHolder',
        name: '名片夹',

        component: resolve => require([`@/views/Redackpc/firstPage/cardHolder/index`], resolve),
    },
    {
        path: '/cardHolder',
        name: '名片夹',
        component: resolve => require([`@/views/Redackpc/firstPage/cardHolder/index`], resolve),
    },






    {
        path: '/cbCenter',
        name: '采编中心',
        // meta: {
        //     title: '采编中心',
        // },
        component: resolve => require([`@/views/Redackpc/firstPage/cbCenter/index`], resolve),
    },
    {
        path: '/Bulletin',
        name: '公告动态',
        // meta: {
        //     title: '公告动态',
        // },
        component: resolve => require([`@/views/Redackpc/firstPage/Bulletin/index`], resolve),
    },
    {
        path: '/carDetails',
        name: '',
        // meta: {
        //     title: '公告动态',
        // },
        component: resolve => require([`@/views/Redackpc/firstPage/Bulletin/card_details/index`], resolve),
    },

    {
        path: '/messageList',
        name: '',
        // meta: {
        //     title: '消息列表',
        // },
        component: resolve => require([`@/views/Redackpc/firstPage/messageList/index`], resolve),
    },

    ],
}, {
    path: '/firstPage',
    name: '',
    // meta: {
    //     title: '',
    // },
    component: resolve => require([`@/views/Redackpc/firstPage/index`], resolve),
},
//cardCollection
{
    path: '/cardCollection',
    name: '名片夹',
    component: resolve => require([`@/views/Redackpc/firstPage/wxcard/cardList/index`], resolve),
},
//usercenter
{
    path: '/myData',
    name: '个人中心',
    component: resolve => require([`@/views/Redackpc/firstPage/wxcard/usercenter/index`], resolve),
},
{
    path: '/login',
    name: '登录注册',
    component: resolve => require([`@/views/Redackpc/firstPage/wxcard/loding/index`], resolve),
},
]
